export enum RequestActionTypeEnum {
    /**
     * Set the request on the 'Expired' status
     */
    Purge = "Purge",
    /**
     * REMOVES the entire request from our platform
     */
    Delete = "Delete",
    /**
     * Withdraw the request
     */
    Withdraw = "Withdraw",
    /**
     * 'Restore' the request from the Expired/Purged state
     */
    Restore = "Restore",
    /**
     * Download the request (NOT ACTOR ACTION)
     */
    Download = "Download",
    /**
     * 'Download' the request to a cloud (NOT ACTOR ACTION)
     */
    Export = "Export",
    /**
     * Become the 'Owner' of the request
     */
    BecomeOwner = "BecomeOwner",
    /**
     *  change the current deadline of a sendgroup
     */
    EditDeadline = "EditDeadline",
    /**
     * Send a reminder email to a sendgroup/Actor
     */
    SendReminder = "SendReminder",
    /**
     * Edit the contact information of a Person
     */
    EditUserDetails = "EditUserDetails",
    /**
     * STATUS SCREEN
     */
    View = "View",
    /**
     * Edit the information of a Sendgroup
     */
    EditSendGroup = "EditSendGroup",
    /**
     * why wait, when you can take a peek right NOW!
     */
    TakeAPeekAtInvite = "TakeAPeekAtInvite",
    /**
     * Change the workgroup of a request
     */
    ChangeWorkGroup = "ChangeWorkGroup",
    /**
     * Show the document of a request
     */
    ShowDocument = "ShowDocument",
    /**
     * Change the signature provider of a actor
     */
    ChangeSignatureProvider = "ChangeSignatureProvider",
    /**
     * Go to the request
     */
    GoToRequest = "GoToRequest",
    /**
     * Edit the request
     */
    EditRequest = "EditRequest",
    /**
     * Edit filing data of the request
     */
    EditFilingData = "EditFilingData",
}